import type {EventHashedID} from '@Components/events/events.types';
import {MY_STUFF_HASHES} from '@Libraries/my-stuff/my-stuff-library';

/** The event whose promote-page chat made the design open in this wizard, set by the wizard's controller. */
export const getPromotionChatEventHashId = (): EventHashedID | null => {
  const eventHashedId: unknown = window.reactPageProps.promotionChatEventHashId;
  return typeof eventHashedId === 'string' && eventHashedId !== '' ? eventHashedId : null;
};

const getEventPromotePageHash = (eventHashedId: EventHashedID): string => {
  return `${MY_STUFF_HASHES.promoteEvent}/${eventHashedId}`;
};

// An opener in another tab is a different realm, so `instanceof Window` cannot recognise it.
const isWindow = (value: unknown): value is Window => {
  return typeof value === 'object' && value !== null && 'location' in value && 'closed' in value;
};

/** The tab that opened this one, when it is the event's promote page and still open. */
const getEventPromotePageOpener = (eventHashedId: EventHashedID): Window | null => {
  const opener: unknown = window.opener;
  if (!isWindow(opener) || opener.closed) {
    return null;
  }

  try {
    return opener.location.hash.startsWith(getEventPromotePageHash(eventHashedId)) ? opener : null;
  } catch {
    // A cross-origin opener's location cannot be read.
    return null;
  }
};

/** Back to the event's promote page: closes this tab when that page opened it, otherwise opens the page here. */
export const returnToEventPromotePage = (eventHashedId: EventHashedID): void => {
  const promotePageOpener = getEventPromotePageOpener(eventHashedId);
  if (promotePageOpener) {
    promotePageOpener.focus();
    window.close();
    return;
  }

  window.location.href = window.PMW.util.site_url(`posters/mine${getEventPromotePageHash(eventHashedId)}`);
};
